import { render, staticRenderFns } from "./NewsIALayout.vue?vue&type=template&id=4dde62ad"
import script from "./NewsIALayout.vue?vue&type=script&lang=js"
export * from "./NewsIALayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports